import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CreditCard, ShieldCheck, Truck, Heart } from "lucide-react";

const LEGAL_LINKS = [
  { label: "Conditions Générales de Vente", tab: "cgv" },
  { label: "Mentions Légales", tab: "mentions-legales" },
  { label: "Politique de Confidentialité", tab: "confidentialite" },
  { label: "Livraison & Retours", tab: "livraison-retours" },
];

const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Merci de saisir un email valide");
      return;
    }
    toast.success("Bienvenue dans le club Relax ✦");
    setEmail("");
  };

  return (
    <footer data-testid="site-footer" className="bg-onyx text-[#FAF7F2] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <p className="font-serif text-6xl sm:text-8xl font-light tracking-tight leading-none text-[#FAF7F2]">
              Relax<span className="text-rose-gold">.</span>
            </p>
            <p className="mt-6 text-sm text-stone-400 leading-relaxed max-w-sm">
              Le rituel bio-collagène girly & chic, pensé pour les peaux qui veulent de l'éclat, du confort et un vrai moment pour elles.
            </p>
            <form onSubmit={subscribe} className="mt-8 flex gap-2 max-w-sm" data-testid="footer-newsletter-form">
              <input
                data-testid="footer-newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email beauté"
                className="flex-1 rounded-full bg-white/10 border border-white/15 px-5 py-3 text-sm placeholder:text-stone-500 focus:outline-none focus:border-rose-gold transition-colors"
              />
              <button
                data-testid="footer-newsletter-submit-button"
                type="submit"
                className="rounded-full bg-rose-gold text-onyx px-5 py-3 text-sm font-semibold hover:bg-[#d8a294] transition-colors"
              >
                Rejoindre
              </button>
            </form>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs tracking-widest uppercase text-stone-500 mb-5">La Boutique</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-masque" to="/produit/masque-bio-collagene" className="text-stone-300 hover:text-rose-gold transition-colors">Le Masque Bio-Collagène</Link></li>
              <li><Link data-testid="footer-link-nuit" to="/produit/masque-nuit-collagene" className="text-stone-300 hover:text-rose-gold transition-colors">Le Masque de Nuit</Link></li>
              <li><Link data-testid="footer-link-collection" to="/#collection" className="text-stone-300 hover:text-rose-gold transition-colors">La Collection</Link></li>
              <li><Link data-testid="footer-link-panier" to="/checkout" className="text-stone-300 hover:text-rose-gold transition-colors">Commander</Link></li>
            </ul>
            <div className="mt-8 flex flex-wrap gap-2">
              <span data-testid="footer-badge-cb" className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-[11px] font-mono text-stone-300"><CreditCard size={13} /> Carte Bleue</span>
              <span data-testid="footer-badge-paypal" className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-[11px] font-mono text-stone-300">PayPal</span>
              <span data-testid="footer-badge-secure" className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-[11px] font-mono text-stone-300"><ShieldCheck size={13} /> Paiement sécurisé</span>
            </div>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-xs tracking-widest uppercase text-stone-500 mb-5">Informations Légales</p>
            <ul className="space-y-3 text-sm">
              {LEGAL_LINKS.map((l) => (
                <li key={l.tab}>
                  <Link
                    data-testid={`footer-legal-link-${l.tab}`}
                    to={`/legal?tab=${l.tab}`}
                    className="text-stone-300 hover:text-rose-gold transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex items-center gap-4 text-[11px] font-mono text-stone-500">
              <span className="inline-flex items-center gap-1.5"><Truck size={13} /> Livraison offerte dès 25 €</span>
              <span className="inline-flex items-center gap-1.5"><Heart size={13} /> Satisfait ou remboursé 30 j</span>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] font-mono text-stone-500">
          <p data-testid="footer-copyright">© 2026 Relax Beauté — Tous droits réservés</p>
          <p>Fait avec amour à Paris ✦ TVA incluse</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
